export const availableLanguages = [
    // --- GLOBAL & POPULAR ---
    { label: 'English', value: 'English', category: 'Global & Popular' },
    { label: 'Chinese (Simplified)', value: 'Chinese (Simplified)', category: 'Global & Popular' },
    { label: 'Chinese (Traditional)', value: 'Chinese (Traditional)', category: 'Global & Popular' },
    { label: 'Spanish', value: 'Spanish', category: 'Global & Popular' },
    { label: 'French', value: 'French', category: 'Global & Popular' },
    { label: 'Arabic', value: 'Arabic', category: 'Global & Popular' },
    { label: 'Hindi', value: 'Hindi', category: 'Global & Popular' },
    { label: 'Portuguese', value: 'Portuguese', category: 'Global & Popular' },
    { label: 'Russian', value: 'Russian', category: 'Global & Popular' },
    { label: 'Japanese', value: 'Japanese', category: 'Global & Popular' },
    { label: 'Korean', value: 'Korean', category: 'Global & Popular' },
    { label: 'German', value: 'German', category: 'Global & Popular' },

    // --- SOUTHEAST ASIA ---
    { label: 'Thai', value: 'Thai', category: 'Southeast Asia' },
    { label: 'Vietnamese', value: 'Vietnamese', category: 'Southeast Asia' },
    { label: 'Indonesian', value: 'Indonesian', category: 'Southeast Asia' },
    { label: 'Malay', value: 'Malay', category: 'Southeast Asia' },
    { label: 'Filipino (Tagalog)', value: 'Filipino', category: 'Southeast Asia' },
    { label: 'Burmese', value: 'Burmese', category: 'Southeast Asia' },
    { label: 'Lao', value: 'Lao', category: 'Southeast Asia' },
    { label: 'Khmer', value: 'Khmer', category: 'Southeast Asia' },

    // --- EAST & SOUTH ASIA ---
    { label: 'Bengali', value: 'Bengali', category: 'East & South Asia' },
    { label: 'Punjabi', value: 'Punjabi', category: 'East & South Asia' },
    { label: 'Marathi', value: 'Marathi', category: 'East & South Asia' },
    { label: 'Telugu', value: 'Telugu', category: 'East & South Asia' },
    { label: 'Tamil', value: 'Tamil', category: 'East & South Asia' },
    { label: 'Gujarati', value: 'Gujarati', category: 'East & South Asia' },
    { label: 'Urdu', value: 'Urdu', category: 'East & South Asia' },
    { label: 'Kannada', value: 'Kannada', category: 'East & South Asia' },
    { label: 'Malayalam', value: 'Malayalam', category: 'East & South Asia' },
    { label: 'Sinhala', value: 'Sinhala', category: 'East & South Asia' },
    { label: 'Nepali', value: 'Nepali', category: 'East & South Asia' },
    { label: 'Mongolian', value: 'Mongolian', category: 'East & South Asia' },
    { label: 'Tibetan', value: 'Tibetan', category: 'East & South Asia' },

    // --- MIDDLE EAST & CENTRAL ASIA ---
    { label: 'Turkish', value: 'Turkish', category: 'Middle East & Central Asia' },
    { label: 'Persian (Farsi)', value: 'Persian', category: 'Middle East & Central Asia' },
    { label: 'Hebrew', value: 'Hebrew', category: 'Middle East & Central Asia' },
    { label: 'Kazakh', value: 'Kazakh', category: 'Middle East & Central Asia' },
    { label: 'Uzbek', value: 'Uzbek', category: 'Middle East & Central Asia' },
    { label: 'Azerbaijani', value: 'Azerbaijani', category: 'Middle East & Central Asia' },
    { label: 'Armenian', value: 'Armenian', category: 'Middle East & Central Asia' },
    { label: 'Georgian', value: 'Georgian', category: 'Middle East & Central Asia' },
    { label: 'Pashto', value: 'Pashto', category: 'Middle East & Central Asia' },
    { label: 'Kurdish', value: 'Kurdish', category: 'Middle East & Central Asia' },

    // --- EUROPE ---
    { label: 'Italian', value: 'Italian', category: 'Europe' },
    { label: 'Dutch', value: 'Dutch', category: 'Europe' },
    { label: 'Polish', value: 'Polish', category: 'Europe' },
    { label: 'Swedish', value: 'Swedish', category: 'Europe' },
    { label: 'Norwegian', value: 'Norwegian', category: 'Europe' },
    { label: 'Danish', value: 'Danish', category: 'Europe' },
    { label: 'Finnish', value: 'Finnish', category: 'Europe' },
    { label: 'Greek', value: 'Greek', category: 'Europe' },
    { label: 'Czech', value: 'Czech', category: 'Europe' },
    { label: 'Hungarian', value: 'Hungarian', category: 'Europe' },
    { label: 'Romanian', value: 'Romanian', category: 'Europe' },
    { label: 'Ukrainian', value: 'Ukrainian', category: 'Europe' },
    { label: 'Bulgarian', value: 'Bulgarian', category: 'Europe' },
    { label: 'Croatian', value: 'Croatian', category: 'Europe' },
    { label: 'Serbian', value: 'Serbian', category: 'Europe' },
    { label: 'Slovak', value: 'Slovak', category: 'Europe' },
    { label: 'Lithuanian', value: 'Lithuanian', category: 'Europe' },
    { label: 'Slovenian', value: 'Slovenian', category: 'Europe' },
    { label: 'Latvian', value: 'Latvian', category: 'Europe' },
    { label: 'Estonian', value: 'Estonian', category: 'Europe' },
    { label: 'Icelandic', value: 'Icelandic', category: 'Europe' },
    { label: 'Albanian', value: 'Albanian', category: 'Europe' },
    { label: 'Maltese', value: 'Maltese', category: 'Europe' },
    { label: 'Irish', value: 'Irish', category: 'Europe' },
    { label: 'Welsh', value: 'Welsh', category: 'Europe' },

    // --- AFRICA ---
    { label: 'Swahili', value: 'Swahili', category: 'Africa' },
    { label: 'Amharic', value: 'Amharic', category: 'Africa' },
    { label: 'Yoruba', value: 'Yoruba', category: 'Africa' },
    { label: 'Igbo', value: 'Igbo', category: 'Africa' },
    { label: 'Hausa', value: 'Hausa', category: 'Africa' },
    { label: 'Zulu', value: 'Zulu', category: 'Africa' },
    { label: 'Shona', value: 'Shona', category: 'Africa' },
    { label: 'Somali', value: 'Somali', category: 'Africa' },
    { label: 'Afrikaans', value: 'Afrikaans', category: 'Africa' },
    { label: 'Malagasy', value: 'Malagasy', category: 'Africa' },

    // --- SPECIAL & FUN (THAI) ---
    { label: 'วัยรุ่นตี้ (Gen Z)', value: 'Thai Gen Z slang', category: 'Special & Fun' },
    { label: 'ย้อนยุคอยุธยา', value: 'Ancient Royal Thai (Ayutthaya era)', category: 'Special & Fun' },
    { label: 'สายมูเตลู', value: 'Thai mystical and astrologer style', category: 'Special & Fun' },
    { label: 'ภาษาอีสาน', value: 'Isan (Northeastern Thai dialect)', category: 'Special & Fun' },
    { label: 'ภาษาเหนือ', value: 'Northern Thai dialect', category: 'Special & Fun' },
    { label: 'ภาษาใต้', value: 'Southern Thai dialect', category: 'Special & Fun' }
];